import { Directive, EmbeddedViewRef, inject, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { CurrentService } from '@portal-core/current/services/current.service';
import { AutoUnsubscribe } from '@portal-core/util/auto-unsubscribe.decorator';
import { Subscription } from 'rxjs';

@Directive({ selector: '[mcIfAuthor]' })
@AutoUnsubscribe()
export class IfAuthorDirective implements OnInit {
  private readonly templateRef = inject<TemplateRef<unknown>>(TemplateRef);
  private readonly viewContainer = inject(ViewContainerRef);
  private readonly currentService = inject(CurrentService);

  private viewRef: EmbeddedViewRef<unknown> = null;
  private licenseUserIsAuthorSubscription: Subscription;
  ngOnInit() {
    this.licenseUserIsAuthorSubscription = this.currentService.getCurrentLicenseUserIsAuthor$().subscribe(isAuthor => {
      if (isAuthor) {
        if (!this.viewRef) {
          this.viewRef = this.viewContainer.createEmbeddedView(this.templateRef);
        }
      } else {
        this.viewContainer.clear();
        this.viewRef = null;
      }
    });
  }
}
